import { arc } from 'd3-shape';
import { memo } from 'react';
import styled, { css } from 'styled-components';

const Path = styled.path<{ $clickable: boolean; $opacity?: number }>`
  cursor: ${props => props.$clickable && 'pointer'};
  ${props =>
    props.$opacity !== undefined &&
    css`
      opacity: ${props.$opacity};
    `};
  transition: opacity 0.2s ease-out;
`;

const Arc = memo(({ innerRadius, outerRadius, startAngle, endAngle, ...other }: any) => (
  <Path d={arc()({ innerRadius, outerRadius, startAngle, endAngle })} {...other} />
));

export default Arc;
